import { render } from "./Comic.vue?vue&type=template&id=ca3a0b40"
import script from "./Comic.vue?vue&type=script&lang=js"
export * from "./Comic.vue?vue&type=script&lang=js"

import exportComponent from "/opt/root/mangareader/reader/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__